 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","about":"about","change-password":"change-password","chat":"chat","chat-content~course~student":"chat-content~course~student","chat-content":"chat-content","course":"course","student":"student","cost":"cost","course-detail":"course-detail","dashboard":"dashboard","demo":"demo","faqs":"faqs","faqs-detail":"faqs-detail","find-a-tutor":"find-a-tutor","forgot":"forgot","home":"home","login~register":"login~register","login":"login","register":"register","message":"message","notification":"notification","pay":"pay","st-home":"st-home","st-information":"st-information","st-started":"st-started","teacher":"teacher","teacher-detail":"teacher-detail","tu-account":"tu-account","tu-availability":"tu-availability","tu-holiday":"tu-holiday","tu-home":"tu-home","tu-information":"tu-information","work":"work","work-detail":"work-detail","z":"z"}[chunkId]||chunkId) + "." + {"404":"5ae59cfe","about":"a1b9744c","change-password":"f74d8f6e","chat":"9fc46ea7","chat-content~course~student":"262f1b39","chat-content":"ed0ffd99","course":"1582d738","student":"1ee1cc85","cost":"ae2498e6","course-detail":"cb878fae","dashboard":"7c154025","demo":"20ff1361","faqs":"eb91fe48","faqs-detail":"c13c44ef","find-a-tutor":"f49e31d0","forgot":"3a5929de","home":"69456be9","login~register":"10569da8","login":"ea543c84","register":"36f61967","message":"08ae91bf","notification":"63ecfa54","pay":"7d5ae2ad","st-home":"4611fbfc","st-information":"f2043983","st-started":"3967f999","teacher":"e75743a0","teacher-detail":"9496f9b9","tu-account":"ac32c0d1","tu-availability":"38b99ddd","tu-holiday":"503ffa35","tu-home":"ca8821b0","tu-information":"d105ecfe","work":"2ec3e3b4","work-detail":"d64a877f","z":"02ebce87"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"change-password":1,"chat":1,"chat-content~course~student":1,"chat-content":1,"course":1,"student":1,"cost":1,"course-detail":1,"dashboard":1,"demo":1,"faqs":1,"faqs-detail":1,"find-a-tutor":1,"forgot":1,"home":1,"login~register":1,"login":1,"register":1,"message":1,"notification":1,"pay":1,"st-home":1,"st-information":1,"st-started":1,"teacher":1,"teacher-detail":1,"tu-account":1,"tu-availability":1,"tu-holiday":1,"tu-home":1,"tu-information":1,"work":1,"work-detail":1,"z":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","about":"about","change-password":"change-password","chat":"chat","chat-content~course~student":"chat-content~course~student","chat-content":"chat-content","course":"course","student":"student","cost":"cost","course-detail":"course-detail","dashboard":"dashboard","demo":"demo","faqs":"faqs","faqs-detail":"faqs-detail","find-a-tutor":"find-a-tutor","forgot":"forgot","home":"home","login~register":"login~register","login":"login","register":"register","message":"message","notification":"notification","pay":"pay","st-home":"st-home","st-information":"st-information","st-started":"st-started","teacher":"teacher","teacher-detail":"teacher-detail","tu-account":"tu-account","tu-availability":"tu-availability","tu-holiday":"tu-holiday","tu-home":"tu-home","tu-information":"tu-information","work":"work","work-detail":"work-detail","z":"z"}[chunkId]||chunkId) + "." + {"404":"31d6cfe0","about":"31d6cfe0","change-password":"3877a3b1","chat":"ccba8b1c","chat-content~course~student":"35b1ef53","chat-content":"463f6924","course":"492c272c","student":"7fac9906","cost":"0d6567d3","course-detail":"1b1337d4","dashboard":"49907116","demo":"307fda17","faqs":"4750fd03","faqs-detail":"a8624a74","find-a-tutor":"dd659667","forgot":"f56ec4f3","home":"4ea0de35","login~register":"ef00db4d","login":"4372cecc","register":"2a2c59f2","message":"8b0b7b03","notification":"8ba57600","pay":"3bfe18e5","st-home":"4c71917c","st-information":"45a74fda","st-started":"169a4b93","teacher":"f4a9c277","teacher-detail":"5db847e5","tu-account":"23bc4f8d","tu-availability":"09629b9f","tu-holiday":"63ebc68f","tu-home":"e7d3104e","tu-information":"a96660cd","work":"a7d2fee4","work-detail":"9f5e3f0c","z":"194fcf6d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
